(function () {
    'use strict';

    angular.module('app.core').config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('order-payment',
                {
                    url: '/:langcode/order/payment/:orderId?sellerId?paymentPrice',
                    templateUrl: 'app/satis/satis.odeme.html',
                    controller: 'SatisOdemeController',
                    metaTags: {
                        robots: 'noindex, nofollow'
                    },
                    params: {
                        langcode: {
                            value: ['$translate', function ($translate) {
                                return $translate.use();
                            }]
                        },
                        orderId: { type: 'any', raw: true },
                        sellerId: { type: 'any', raw: true },
                        paymentPrice: { type: 'any', raw: true }
                    },
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'salesPayment');
                        }],
                        order_result: ['orders_factory', '$transition$', function (orders_factory, $transition$) {
                            return orders_factory.get({ id: $transition$.params().orderId }).$promise;
                        }],

                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart('payment');
                            $translatePartialLoader.addPart('factura_address');
                            $translatePartialLoader.addPart('satis_odeme');
                            return $translate.refresh();
                        }]
                    }
                })


    }]);

})();
